export const getListingInfo = (listing, specs, saleStatus, bids, sale = false, isLot = false, isReserveVisible = true, isCurrentBidVisible = true) => {
  const highestBid = !!saleStatus?.highestBidUuid && bids?.[saleStatus?.highestBidUuid]
  const hasEnded = saleStatus?.endsAt < Date.now()
  const isSold = specs?.status === 'SOLD' // && hasEnded
  const isWithdrawn = specs?.status === 'WITHDRAWN' || saleStatus?.withdrawn || saleStatus?.suspended
  const afterSaleEndTime = saleStatus?.endsAt + ((24 * 60 * 60 * 1000) * 90)
  const hasBids = !!saleStatus?.highestBidUuid
  const currentSoftBidValue = highestBid?.amount || sale?.nextBidValue
  // const soldPrice = specs?.price
  // ! [2026-02-28] Fallback on BLX sold price if Ardex sold price is not available.
  const soldPrice = specs?.price || currentSoftBidValue
  const currentBidValue = isCurrentBidVisible
    ? isSold
      ? soldPrice
      : currentSoftBidValue
    : null
  const reserveLabel = () => {
    if (isLot && isReserveVisible) {
      if (sale.reserve) {
        if (hasBids) {
          if (currentSoftBidValue >= sale.reserve) {
            return 'JspPublicCodes_JSP_LISTING_RESERVE_MET'
          } else {
            return 'JspPublicCodes_JSP_LISTING_RESERVE_NOT_MET'
          }
        } else {
          return 'JspPublicCodes_JSP_LISTING_RESERVE_NOT_MET'
        }
      } else {
        return 'JspPublicCodes_JSP_LISTING_RESERVE_NONE'
      }
    }
    return null
  }

  const reserveStatus = () => {
    if (isLot && isReserveVisible) {
      if (sale.reserve) {
        if (hasBids) {
          if (currentSoftBidValue >= sale.reserve) {
            return 'above'
          } else {
            return 'below'
          }
        } else {
          return 'below'
        }
      } else {
        return 'none'
      }
    }
    return null
  }

  const isSoftPassedIn = !isWithdrawn && hasEnded && (!saleStatus?.highestBidUuid || reserveStatus() === 'below')
  const isPassedInSale = isSoftPassedIn && isSold
  const isPassedIn = specs?.status === 'PASSED IN' || isSoftPassedIn
  const isPassedInNoBids = !hasBids && isPassedIn
  const isSoftSold = isSold || (hasEnded && !!highestBid && !isWithdrawn && !isPassedIn && reserveStatus() !== 'below')
  const isProcessing = hasEnded && !!saleStatus?.highestBidUuid && !isSold && !isWithdrawn && !isPassedIn
  const listingHasStatus = isSold || isWithdrawn || isProcessing || isPassedIn
  const isListingClosed = isSoftSold || isSold || isWithdrawn
  // const soldPriceIsDifferent = soldPrice && currentBidValue !== soldPrice
  const currentStatus = isSold ? 'SOLD' : isWithdrawn ? 'WITHDRAWN' : isPassedIn ? 'PASSED IN' : isProcessing ? 'PROCESSING' : 'ACTIVE'

  return {
    hasEnded,
    soldPrice,
    // soldPriceIsDifferent,
    reserveStatus: reserveStatus(),
    reserveLabel: reserveLabel(),
    isSold,
    isSoftSold,
    isWithdrawn,
    isPassedIn,
    isSoftPassedIn,
    isPassedInSale,
    isPassedInNoBids,
    isProcessing,
    isListingClosed,
    afterSaleEndTime,
    listingHasStatus,
    currentBidValue,
    currentStatus
  }
}
